import { journeySteps, sectionShell } from "./landingContent";

/**
 * How it works: the six-step journey as a 3×2 grid of white cards.
 *
 * Cards stretch to a uniform height per row so the badge/title/body rhythm
 * lines up across the row, as drawn in the mock.
 */
export default function HowItWorks() {
  return (
    <section className={`${sectionShell} pt-[76px]`}>
      <h2 className="mb-9 text-pretty text-[36px] font-extrabold tracking-[-0.03em] text-eab-neutral-900 lg:text-[54px]">
        How it works
      </h2>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {journeySteps.map((step) => (
          <div
            key={step.n}
            className="flex flex-col gap-3.5 rounded-[26px] bg-white p-[30px] transition-shadow duration-150 ease-out hover:shadow-eab-card"
          >
            <span
              className={`flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-full text-[19px] font-bold ${step.badge}`}
              aria-hidden="true"
            >
              {step.n}
            </span>
            <h3 className="text-pretty text-[22px] font-bold leading-[1.2] tracking-[-0.015em] text-eab-neutral-900">
              {step.title}
            </h3>
            <p className="text-pretty text-[15px] leading-[1.6] text-eab-neutral-700">
              {step.body}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
